import { useSidebar } from '@ibsys/kit';

/**
 * Признак свёрнутого до иконок левого меню.
 *
 * Единственное место, где задана трактовка свёрнутости: на мобильном меню раскрывается поверх
 * содержимого во всю ширину — узкой колонки иконок там нет, поэтому свёрнутым оно не считается
 * ни при каком состоянии кита. Собранное вручную у потребителя то же выражение разошлось бы
 * между шапкой меню и его пунктами при следующей правке трактовки.
 */
export const useIsSidebarCollapsed = (): boolean => {
  const { state, isMobile } = useSidebar();

  return !isMobile && state === 'collapsed';
};
